import { render, staticRenderFns } from "./applyForAfterSales.vue?vue&type=template&id=48be5178&scoped=true&"
import script from "./applyForAfterSales.vue?vue&type=script&lang=js&"
export * from "./applyForAfterSales.vue?vue&type=script&lang=js&"
import style0 from "./applyForAfterSales.vue?vue&type=style&index=0&id=48be5178&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48be5178",
  null
  
)

export default component.exports